module.exports = __webpack_public_path__ + "static/media/ระกา.abd73b5f.png";